// eslint-disable-next-line import/prefer-default-export
export const muiMenuItemComponent = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.main.professional_blue,
      padding: theme.spacing('LARGE'),
      textDecoration: 'none',
      width: '100%',

      [`& > div`]: {
        alignItems: 'center',
        display: 'flex',
        columnGap: theme.spacing('LARGE'),
      },

      [`&:not(:last-child)`]: {
        borderBottom: `1px solid ${theme.palette.gray.light_gray}`,
      },

      [`&:hover`]: {
        backgroundColor: theme.palette.background.popupMenuLink,
      },

      [`&:active`]: {
        textDecoration: 'underline',
        color: theme.palette.text.navMenuLinkHover,
      },

      [`&.Mui-focusVisible`]: {
        backgroundColor: theme.palette.background.popupMenuLink,
        border: 'none',
        borderBottom: `1px solid ${theme.palette.gray.light_gray}`,
      },

      [`&.Mui-focusVisible > div`]: {
        border: `2px solid ${theme.palette.main.accent_blue}`,
        borderRadius: '2px',
        outline: 'none',
      },

      [`&.Mui-disabled`]: {
        opacity: '1',
      },

      [`&.Mui-selected`]: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.main.product_blue,

        [`&:hover, &.Mui-focusVisible`]: {
          backgroundColor: theme.palette.background.popupMenuLink,
        },
      },
    }),
    dense: ({ theme }) => ({
      padding: theme.spacing('NONE'),
    }),
  },
};
